import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import trans_en_GB from "./translations/en";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: trans_en_GB,
    },
  },
  lng: "en",
  fallbackLng: "en",
  debug: false,

  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export default i18n;
